export type EvidenceTable = {
  headers: string[]
  body: string[][]
  problemRows: Record<number, boolean>
}

export const blankHeaderPlaceholder = 'TRUSTERO_BLANK_HEADER_PLACEHOLDER'
